import { connect } from 'react-redux';
import CRUDActions from '../../../actions/player';
import PlayersNew from './PlayersNew';


export default connect(
  ({player: {loadingItem, model}}) => ({
    loading: loadingItem,
    model,
    initialValues: Object.assign({}, model)
  }),
  dispatch => ({
    fetch: () => dispatch(CRUDActions.createModel())
  })
)(PlayersNew)



// WEBPACK FOOTER //
// ./src/components/Players/PlayersNew/index.js